import React from 'react';
import { ContentContainer, PageContainer, Paragraph, SectionTitle, Title } from './TermsPage.styles';
import { ContentSafeAreaView } from '../../components';

const TermsPage = () => {
  return (
    <PageContainer>
      <ContentSafeAreaView removeBottom hideLogo>
        <ContentContainer>
          <Title>Terms and Conditions</Title>
          <SectionTitle>1. Introduction</SectionTitle>
          <Paragraph />
        </ContentContainer>
      </ContentSafeAreaView>
    </PageContainer>
  );
};

export default TermsPage;
